import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import * as m from "~/paraglide/messages";
import { orpc } from "~/lib/orpc-client";

/* ── Top bar pricing link -- upgrade for free, hidden for paid ── */

export function TopBarPricingLink() {
  const creditQuery = useQuery(orpc.credits.getBalance.queryOptions());
  const tier = creditQuery.data?.tier;

  // Hide for paid users (student, pro, lifetime)
  if (tier && tier !== "free") return null;

  return (
    <Link to="/pricing" className="btn-ghost btn-sm hidden sm:inline-flex">
      {tier === "free" ? m.common_upgrade() : m.nav_pricing()}
    </Link>
  );
}
